import { url, earthidealAPIURL } from '../constants'
import JwtDecode from 'jwt-decode'
import {ApiService} from "../services"

export const PMGroupsService = {
  getCompanyImbalances,
  getResourceCompanyImbalances,
  addPmGroup,
  addPmGroupMembers,
  removePmGroupMembers,
  getPmGroupByEmail,
  getPmGroupMembersByEmail,
  getMasterTableInfo,
  getNewSubscriptionData,
  setGroupSubscription,
  deletePmGroup
}

async function getCompanyImbalances(email) {
  const resp = await fetch(`${earthidealAPIURL}/pmgroups/getcompanyimbalances/${email}`).then(handleResponse)
  return resp.resourcesSitesList
}


async function getResourceCompanyImbalances(email, idsiteresource, tallyViews) {
  let data = {email, idsiteresource, tallyViews}

   const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }

  const resp = await fetch(`${earthidealAPIURL}/pmgroups/getResourceCompanyImbalances`, requestOptions).then(handleResponse)
  return resp
}


async function addPmGroup(data) {

  data.invitingUserEmail = ApiService.getJWTEmail();

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }

  const resp = await fetch(`${earthidealAPIURL}/pmgroups/add`, requestOptions)
    .then(handleResponse)

  return resp
}

async function addPmGroupMembers(data) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }

  const resp = await fetch(`${earthidealAPIURL}/pmgroups/addToPmGroup`, requestOptions)
    .then(handleResponse)

  return resp
}

async function removePmGroupMembers(data) {
  const userJWT = localStorage.getItem('token')
  const userDecoded = JwtDecode(userJWT)
  const username = userDecoded ? userDecoded['cognito:username'] : null

  data.username = username;

  console.log("removePmGroupMembers username:", username);

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }

  const resp = await fetch(`${earthidealAPIURL}/pmgroups/removeFromPmGroup`, requestOptions)
    .then(handleResponse)

  return resp
}

async function getPmGroupByEmail(email, origin) {
  //console.log("Calling getPmGroupByEmail from " + origin);
  if (email){
    const resp = await fetch(`${earthidealAPIURL}/pmgroups/getpmgroupbyemail/${email}`).then(handleResponse)
    return resp.pmGroup
  } else return null;
}

async function getPmGroupMembersByEmail(email, origin) {
  //console.log("Calling getPmGroupMembersByEmail from " + origin);
  const resp = await fetch(`${earthidealAPIURL}/pmgroups/getpmgroupmembers/${email}`).then(handleResponse)
  return resp.members
}


async function getMasterTableInfo() {
  const userJWT = localStorage.getItem('token')
  const userDecoded = JwtDecode(userJWT)
  const username = userDecoded ? userDecoded['cognito:username'] : null
  const email = userDecoded ? userDecoded['email'] : null;

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({username, email})
  }

  const resp = await fetch(`${earthidealAPIURL}/pmgroups/getMasterTableInfo`, requestOptions)
    .then(handleResponse)

  return resp.masterTableInfo;
}

async function getNewSubscriptionData(){

  const userJWT = localStorage.getItem('token')
  const userDecoded = JwtDecode(userJWT)
  const email = userDecoded ? userDecoded['email'] : null;


   //console.log("Calling getPmGroupMembersByEmail from " + origin);
  const resp = await fetch(`${earthidealAPIURL}/pmgroups/getNewSubscriptionData/${email}`).then(handleResponse)
  return resp.data
}

async function setGroupSubscription(data) {
  const userJWT = localStorage.getItem('token')
  const userDecoded = JwtDecode(userJWT)
  const username = userDecoded ? userDecoded['cognito:username'] : null
  const email = userDecoded ? userDecoded['email'] : null;

  data.email = email;
  data.username = username;

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({data})
  }

  const resp = await fetch(`${earthidealAPIURL}/pmgroups/setGroupSubscription`, requestOptions)
    .then(handleResponse)

  return resp;
}


async function deletePmGroup(idpmgroup) {
  const userJWT = localStorage.getItem('token')
  const userDecoded = JwtDecode(userJWT)
  const username = userDecoded ? userDecoded['cognito:username'] : null
  const email = userDecoded ? userDecoded['email'] : null;

  let data = {email, username, idpmgroup}


  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({data})
  }

  const resp = await fetch(`${earthidealAPIURL}/pmgroups/deletePmGroup`, requestOptions)
    .then(handleResponse)

  return resp;
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}
